import { getRequest, postRequest, formRequest } from "./axios";
// import xm from "@/js/utils"
// let getToken = xm.getToken;
// let bese = '/reserve'
// 初始化
export function pageInfo() {
  return getRequest('/init');
}
// 题目
export function question() {
  return getRequest('/reserve/questionslist');
}
//答案
export function answer(data, header) {
  return postRequest('/reserve/weaponstest', data, header);
}
// 預約
export function subscribe(data) {
  return formRequest('/mobile', data);
}
// 用户信息
export function info(data) {
  return getRequest('/info', null, data);
}
// 分享
export function share(data) {
  return getRequest('/share', null, data)
}
// 商店预约
export function shopSubscribe(data) {
  return getRequest('/store', null, data)
}
// fb点赞
export function fblike(data) {
  return getRequest('/fblike', null, data)
}
// 获取奖励列表
export function codes(data) {
  return getRequest('/codes', null, data)
}
// 领取奖励结果
export function testreward (data) {
  return getRequest('/testreward ', null, data)
}
// // 基本信息
// export function minfo() {
//   let data = getPhoneData();
//   return formRequest(bese + '/minfo', data);
// }

